import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ConcernsSection from '../components/ConcernsSection';
import BenefitsSection from '../components/BenefitsSection';
import BeforeAfterSection from '../components/BeforeAfterSection';
import ServiceFlowSection from '../components/ServiceFlowSection';
import PricingSection from '../components/PricingSection';
import AreaSection from '../components/AreaSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const HakajimaiLanding = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-stone-50 to-stone-100">
      <Header />
      <HeroSection />
      <BeforeAfterSection />
      <ConcernsSection />
      <BenefitsSection />
      <ServiceFlowSection />
      <PricingSection />
      <AreaSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HakajimaiLanding;
